import { MyMonitoringAccountDetailsPage } from '@apps-common/apps/portal/pages/my-monitoring/pages/details/Index'

export const MyMonitoringAccountDetails = () => <MyMonitoringAccountDetailsPage />
